import { Outputs as ImportOutputs } from "./outputs";
import { Batteries as ImportBatteries } from "./batteries";
import { PowerSupplies as ImportPowerSupplies } from "./powerSupplies";
import { Inputs as ImportInputs } from "./inputs";
import { Timers as ImportTimers } from "./timers";
import { Flags as ImportFlags } from "./flags";
import { State as ImportState } from "./state";
import { Dispatch } from "redux";
import * as ImportEpics from "./epics";
import * as ImportReducers from "./state/reducers";

export namespace Linq8acm {
  export type State = ImportState;
  export const Epics = ImportEpics.default;
  export const Reducer = ImportReducers.default;
  export import Outputs = ImportOutputs;
  export import Batteries = ImportBatteries;
  export import PowerSupplies = ImportPowerSupplies;
  export import Flags = ImportFlags;
  export import Inputs = ImportInputs;
  export import Timers = ImportTimers;

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      dispatch: {
        outputs: Outputs.Actions.bindDispatchProps(dispatch),
        powerSupplies: PowerSupplies.Actions.bindDispatchProps(dispatch),
        batteries: Batteries.Actions.bindDispatchProps(dispatch),
        flags: Flags.Actions.bindDispatchProps(dispatch),
        inputs: Inputs.Actions.bindDispatchProps(dispatch),
        timers: Timers.Actions.bindDispatchProps(dispatch)
      }
    };
  };
}
